import { render, staticRenderFns } from "./userThreparty.vue?vue&type=template&id=40ca9756"
import script from "./userThreparty.vue?vue&type=script&lang=js"
export * from "./userThreparty.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/login/userThreparty.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/login/userThreparty.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports